import {
  CryptoCurrencyTypes,
  DangerZoneStates,
  IncidentTypeStates,
  MarketPeriods,
  MarketTypes,
  RunnerTypes,
  SportsNameType,
} from "../utils/const";
export class TranslationHelper {
  // TODO The following has  markets and market periods mixed
  // https://ns90ltd.atlassian.net/browse/BET-13407
  static getTranslationIdForMarket(
    marketType: string,
    marketPeriod?: string | null,
    sport?: string | null,
    shortened?: boolean
  ): string {
    switch (marketType) {
      case MarketPeriods.FULL_EVENT:
        return "markets-full";

      case MarketPeriods.COMPLETE_EVENT:
        return "markets-complete-event";

      case MarketPeriods.REGULATION_TIME:
        return "regulation-time";

      case MarketPeriods.FIRST_HALF:
        return "markets-firsthalf";

      case MarketPeriods.SECOND_HALF:
        return "markets-secondhalf";

      case MarketPeriods.EXTRA_TIME:
        return "markets-extra-time";

      case MarketPeriods.FIRST_PERIOD:
        if (shortened) {
          return "markets-first-period-short";
        } else {
          return "markets-first-period";
        }

      case MarketPeriods.SECOND_PERIOD:
        if (shortened) {
          return "markets-second-period-short";
        } else {
          return "markets-second-period";
        }

      case MarketPeriods.THIRD_PERIOD:
        if (shortened) {
          return "markets-third-period-short";
        } else {
          return "markets-third-period";
        }

      case MarketPeriods.FIRST_QUARTER:
        if (shortened) {
          return "markets-first-quarter-short";
        } else {
          return "markets-first-quarter";
        }

      case MarketPeriods.SECOND_QUARTER:
        if (shortened) {
          return "markets-second-quarter-short";
        } else {
          return "markets-second-quarter";
        }

      case MarketPeriods.THIRD_QUARTER:
        if (shortened) {
          return "markets-third-quarter-short";
        } else {
          return "markets-third-quarter";
        }

      case MarketPeriods.FOURTH_QUARTER:
        if (shortened) {
          return "markets-fourth-quarter-short";
        } else {
          return "markets-fourth-quarter";
        }

      case MarketPeriods.MAP_1:
        return "markets-first-map";

      case MarketPeriods.MAP_2:
        return "markets-second-map";

      case MarketPeriods.MAP_3:
        return "markets-third-map";

      case MarketPeriods.MAP_4:
        return "markets-fourth-map";

      case MarketPeriods.MAP_5:
        return "markets-fifth-map";

      case MarketPeriods.FIRST_FIVE_INNINGS:
        return "markets-first-five-innings";

      case MarketTypes.PLAYER_TOTAL_ASSISTS_ROLLING:
        return "markets-player-total-assists-rolling";
      case MarketTypes.PLAYER_TOTAL_POINTS_ROLLING:
        return "markets-player-total-points-rolling";
      case MarketTypes.PLAYER_TOTAL_GOALS_ROLLING:
        return "markets-player-total-goals-rolling";
      case MarketTypes.PLAYER_TOTAL_SHOTS_ROLLING:
        return "markets-player-total-shots-rolling";
      case MarketTypes.PLAYER_TOTAL_BLOCKS_ROLLING:
        return "markets-player-total-blocks-rolling";
      case MarketTypes.PLAYER_TOTAL_STEALS_ROLLING:
        return "markets-player-total-steals-rolling";
      case MarketTypes.PLAYER_TOTAL_REBOUNDS_ROLLING:
        return "markets-player-total-rebounds-rolling";
      case MarketTypes.TOUCHDOWN_SCORER_ANYTIME:
        return "markets-touchdown-scorer-anytime";
      case MarketTypes.PLAYER_TOUCHDOWN_2_PLUS:
        return "markets-player-touchdown-2-plus";
      case MarketTypes.FULL_CORNERS:
        return "markets-full-corners";
      case MarketTypes.TOTAL_CARDS_AWAY:
        return "markets-total-cards-away";
      case MarketTypes.TOTAL_CARDS:
        return "markets-total-cards";
      case MarketTypes.TOTAL_CARDS_HOME:
        return "markets-total-cards-home";
      case MarketTypes.FIRST_CARDED_TEAM:
        return "markets-first-carded-team";

      case MarketTypes.HANDICAP:
        if (sport === SportsNameType.TENNIS) {
          return "markets-match-handicap";
        } else if (sport === SportsNameType.ESPORTS) {
          return "markets-map-handicap";
        } else {
          return "markets-handicap";
        }

      case MarketTypes.ASIAN_HANDICAP:
        return "markets-asian-handicap";

      case MarketTypes.SET_HANDICAP:
        return "markets-set-handicap";

      case MarketTypes.SET_TOTAL:
        return "markets-set-total";

      case MarketTypes.TOTAL:
        if (sport === SportsNameType.TENNIS) {
          return "markets-match-total";
        } else if (sport === SportsNameType.ESPORTS) {
          return "markets-total-maps";
        } else {
          return "markets-total";
        }

      case MarketTypes.MONEY_LINE:
        if (sport === SportsNameType.ESPORTS) {
          if (marketPeriod === "FULL_EVENT") {
            return "markets-match-winner";
          } else if (marketPeriod?.includes("MAP_")) {
            return "markets-map-match-winner";
          }
        }
        return "markets-moneyline";

      case MarketTypes.MATCH_ODDS:
        return "markets-matchodds";

      case MarketTypes.MATCH_ODDS_THREE_WAY:
        return "markets-matchodds";

      case MarketTypes.ONE_X_TWO:
        return "markets-1x2";

      case MarketTypes.CORRECT_SCORE:
        return "markets-correct-score";

      case MarketTypes.CORNER_TOTAL:
        return "markets-corner-total";

      case MarketTypes.CORNER_HANDICAP:
        return "markets-corner-handicap";

      case MarketTypes.CORNER_ASIAN_HANDICAP:
        return "markets-corner-asian-handicap";

      case MarketTypes.CORNER_MONEY_LINE:
        return "markets-corner-moneyline";

      case MarketTypes.CORNER_ONE_X_TWO:
        return "markets-corner-1x2";

      case MarketTypes.TOTAL_GOALS:
        if (sport === SportsNameType.BASEBALL) {
          return "markets-total-runs";
        } else {
          return "markets-total-goals";
        }

      case MarketTypes.TOTAL_HOME:
        if (sport === SportsNameType.BASEBALL) {
          return "markets-total-runs-home";
        } else {
          return "markets-total-goals-home";
        }

      case MarketTypes.TOTAL_AWAY:
        if (sport === SportsNameType.BASEBALL) {
          return "markets-total-runs-away";
        } else {
          return "markets-total-goals-away";
        }

      case MarketTypes.TOTAL_GOALS_HOME:
        if (sport === SportsNameType.BASEBALL) {
          return "markets-total-runs-home";
        } else {
          return "markets-total-goals-home";
        }

      case MarketTypes.TOTAL_GOALS_AWAY:
        if (sport === SportsNameType.BASEBALL) {
          return "markets-total-runs-away";
        } else {
          return "markets-total-goals-away";
        }

      case MarketTypes.MATCH_TIE:
        return "markets-match-tie";

      case MarketTypes.TOTAL_POINTS_HOME:
        return "markets-total-points-home";

      case MarketTypes.TOTAL_POINTS_AWAY:
        return "markets-total-points-away";

      case MarketTypes.WINNING_MARGIN:
        return "markets-winning-margin";

      case MarketTypes.THREE_WAY_AND_TOTAL:
        return "markets-1x2-ou";

      case MarketTypes.THREE_WAY_AND_BOTH_SCORE:
        return "markets-1x2-both-score";

      case MarketTypes.FIRST_LAST_GOAL:
        return "markets-first-last-goal";

      case MarketTypes.FIRST_GOAL:
        return "markets-first-goal";

      case MarketTypes.LAST_GOAL:
        return "markets-last-goal";

      case MarketTypes.NO_GOAL:
        return "markets-no-goal";

      case MarketTypes.TOTAL_ODD_EVEN:
        if (
          sport === SportsNameType.AMERICAN_FOOTBALL ||
          sport === SportsNameType.BASKETBALL
        ) {
          return "markets-total-points-odd-even";
        } else if (sport === SportsNameType.BASEBALL) {
          return "markets-total-runs-odd-even";
        } else {
          return "markets-total-odd-even";
        }

      case MarketTypes.TOTAL_ODD_EVEN_HOME:
        if (sport === SportsNameType.BASEBALL) {
          return "markets-oddeven-runs-home";
        } else {
          return "markets-oddeven-points-home";
        }

      case MarketTypes.TOTAL_ODD_EVEN_AWAY:
        if (sport === SportsNameType.BASEBALL) {
          return "markets-oddeven-runs-away";
        } else {
          return "markets-oddeven-points-away";
        }

      case MarketTypes.RACE_TO:
        return "markets-race-to";

      case MarketTypes.CLEAN_SHEET:
        return "markets-clean-sheet";

      case MarketTypes.WIN_TO_NIL:
        return "markets-win-to-nil";

      case MarketTypes.DRAW_NO_BET:
        return "markets-draw-no-bet";

      case MarketTypes.BOTH_SCORE:
        return "markets-both-score";

      case MarketTypes.BOTH_SCORE_AND_TOTAL:
        return "markets-both-score-and-total";

      case MarketTypes.HALF_MOST_GOALS:
        return "markets-half-most-goals";

      case MarketTypes.DOUBLE_CHANCE:
        return "markets-double-chance";

      case MarketTypes.HALF_FULL_TIME:
        if (shortened) {
          return "markets-ht-ft";
        } else {
          return "markets-half-full-time";
        }

      case MarketTypes.EXTRA_TIME_HALF:
        return "markets-extra-time-half";

      case MarketTypes.WINNER_INTERVAL_1_15:
        return "markets-winner-interval-15";

      case MarketTypes.WINNER_INTERVAL_16_30:
        return "markets-winner-interval-30";

      case MarketTypes.WINNER_INTERVAL_31_45:
        return "markets-winner-interval-45";

      case MarketTypes.WINNER_INTERVAL_46_60:
        return "markets-winner-interval-60";

      case MarketTypes.WINNER_INTERVAL_61_75:
        return "markets-winner-interval-75";

      case MarketTypes.WINNER_INTERVAL_76_90:
        return "markets-winner-interval-90";
      case MarketTypes.OVERTIME:
        return "markets-overtime";
      case MarketTypes.HIGHEST_SCORING_QUARTER:
        return "markets-highest-scoring-quarter";
      case MarketTypes.TEAM_HIGHEST_SCORING_QUARTER:
        return "markets-team-highest-scoring-quarter";
      case MarketTypes.HIGHEST_SCORING_QUARTER_AND_TEAM:
        return "markets-highest-scoring-quarter-and-team";
      case MarketTypes.LAST_POINT:
        return "markets-last-point";
      case MarketTypes.MONEYLINE_AND_TOTAL:
        return "markets-moneyline-total";

      case MarketTypes.GOALSCORER_1ST:
        return "markets-1st-goalscorer";
      case MarketTypes.GOALSCORER_2ND:
        return "markets-2nd-goalscorer";
      case MarketTypes.GOALSCORER_3RD:
        return "markets-3rd-goalscorer";
      case MarketTypes.GOALSCORER_4TH:
        return "markets-4th-goalscorer";
      case MarketTypes.GOALSCORER_5TH:
        return "markets-5th-goalscorer";
      case MarketTypes.GOALSCORER_6TH:
        return "markets-6th-goalscorer";
      case MarketTypes.GOALSCORER_7TH:
        return "markets-7th-goalscorer";
      case MarketTypes.GOALSCORER_8TH:
        return "markets-8th-goalscorer";
      case MarketTypes.GOALSCORER_9TH:
        return "markets-9th-goalscorer";
      case MarketTypes.GOALSCORER_10TH:
        return "markets-10th-goalscorer";
      case MarketTypes.GOALSCORER_11TH:
        return "markets-11th-goalscorer";
      case MarketTypes.GOALSCORER_12TH:
        return "markets-12th-goalscorer";
      case MarketTypes.GOALSCORER_13TH:
        return "markets-13th-goalscorer";
      case MarketTypes.GOALSCORER_14TH:
        return "markets-14th-goalscorer";
      case MarketTypes.GOALSCORER_15TH:
        return "markets-15th-goalscorer";
      case MarketTypes.GOALSCORER_LAST:
        return "markets-last-goalscorer";
      case MarketTypes.GOALSCORER_ANYTIME:
        return "markets-anytime-goalscorer";

      case MarketTypes.TOUCHDOWN_SCORED:
        return "markets-touchdown-scored";
      case MarketTypes.TOTAL_TOUCHDOWNS:
        return "markets-total-touchdowns";
      case MarketTypes.TOUCHDOWN_TEAM_SCORER_1ST:
        return "markets-1st-touchdown";
      case MarketTypes.TOUCHDOWN_TEAM_SCORER_2ND:
        return "markets-2nd-touchdown";
      case MarketTypes.TOUCHDOWN_TEAM_SCORER_3RD:
        return "markets-2nd-touchdown";
      case MarketTypes.TOUCHDOWN_TEAM_SCORER_4TH:
        return "markets-4th-touchdown";
      case MarketTypes.TOUCHDOWN_TEAM_SCORER_5TH:
        return "markets-5th-touchdown";
      case MarketTypes.TOUCHDOWN_TEAM_SCORER_6TH:
        return "markets-6th-touchdown";
      case MarketTypes.TOUCHDOWN_TEAM_SCORER_7TH:
        return "markets-7th-touchdown";
      case MarketTypes.TOUCHDOWN_TEAM_SCORER_8TH:
        return "markets-8th-touchdown";
      case MarketTypes.TOUCHDOWN_TEAM_SCORER_9TH:
        return "markets-9th-touchdown";
      case MarketTypes.TOUCHDOWN_TEAM_SCORER_10TH:
        return "markets-10th-touchdown";
      case MarketTypes.TOUCHDOWN_SCORER_1ST:
        return "markets-1st-touchdown-scorer";
      case MarketTypes.TOUCHDOWN_SCORER_2ND:
        return "markets-2nd-touchdown-scorer";
      case MarketTypes.TOUCHDOWN_SCORER_3RD:
        return "markets-3rd-touchdown-scorer";
      case MarketTypes.TOUCHDOWN_SCORER_4TH:
        return "markets-4th-touchdown-scorer";
      case MarketTypes.TOUCHDOWN_SCORER_5TH:
        return "markets-5th-touchdown-scorer";
      case MarketTypes.TOUCHDOWN_SCORER_6TH:
        return "markets-6th-touchdown-scorer";
      case MarketTypes.TOUCHDOWN_SCORER_7TH:
        return "markets-7th-touchdown-scorer";
      case MarketTypes.TOUCHDOWN_SCORER_8TH:
        return "markets-8th-touchdown-scorer";
      case MarketTypes.TOUCHDOWN_SCORER_9TH:
        return "markets-9th-touchdown-scorer";
      case MarketTypes.TOUCHDOWN_SCORER_10TH:
        return "markets-10th-touchdown-scorer";
      case MarketTypes.PLAYER_TOTAL_RUSHING_YARDS_ROLLING:
        return "player-total-rushing-yards-rolling";
      case MarketTypes.PLAYER_TOTAL_RUSHING_ATTEMPTS_ROLLING:
        return "player-total-rushing-attempts-rolling";
      case MarketTypes.PLAYER_TOTAL_RECEIVING_YARDS_ROLLING:
        return "player-total-receiving-yards-rolling";
      case MarketTypes.PLAYER_TOTAL_RECEPTIONS_ROLLING:
        return "player-total-receptions-rolling";
      case MarketTypes.PLAYER_TOTAL_PASSING_YARDS_ROLLING:
        return "player-total-passing-yards-rolling";
      case MarketTypes.PLAYER_TOTAL_PASSING_ATTEMPTS_ROLLING:
        return "player-total-passing-attempts-rolling";
      case MarketTypes.PLAYER_TOTAL_PASS_COMPLETIONS_ROLLING:
        return "player-total-pass-completions-rolling";
      case MarketTypes.PLAYER_TOTAL_PASSING_TOUCHDOWNS_ROLLING:
        return "player-total-passing-touchdowns-rolling";
      case MarketTypes.PLAYER_TOTAL_ASSISTS_ROLLING:
        return "markets-player-total-assists-rolling";
      case MarketTypes.PLAYER_TOTAL_GOALS_ROLLING:
        return "markets-player-total-goals-rolling";
      case MarketTypes.PLAYER_TOTAL_SHOTS_ROLLING:
        return "markets-player-total-shots-rolling";
      case MarketTypes.PLAYER_TOTAL_POINTS_ROLLING:
        return "markets-player-total-points-rolling";
      case MarketTypes.PLAYER_TOTAL_RECEPTIONS_ROLLING:
        return "markets-player-total-receptions-rolling";
      case MarketTypes.OUTRIGHT:
        return "markets-outright";
      case MarketTypes.FIGHT_GOES_DISTANCE:
        return "markets-fight-goes-distance";
      case MarketTypes.METHOD_OF_VICTORY:
        return "markets-method-of-victory";
      case MarketTypes.WINNER_OF_TIE:
        return "markets-winner-of-tie";
      case MarketTypes.TOTAL_ROUNDS_COMPLETED:
        return "markets-total-rounds-completed";
      case MarketTypes.ROUND_BETTING:
        return "markets-round-betting";

      case MarketTypes.TOTAL_KILLS:
        return "markets-total-kills";
      case MarketTypes.HANDICAP_KILLS:
        return "markets-handicap-kills";
      case MarketTypes.MOST_KILLS:
        return "markets-most-kills";
      case MarketTypes.TOTAL_KILLS_HOME:
        return "markets-total-kills-home";
      case MarketTypes.TOTAL_KILLS_AWAY:
        return "markets-total-kills-away";
      case MarketTypes.PLAYER_SCORE_OUTSIDE_AREA:
        return "markets-player-score-outside-area";
      case MarketTypes.PLAYER_ASSISTS:
        return "markets-player-assists";
      case MarketTypes.PLAYER_ASSISTS_2_PLUS:
        return "markets-player-assists-2-plus";
      case MarketTypes.PLAYER_SCORE_AND_ASSIST:
        return "markets-player-score-and-assist";
      case MarketTypes.PLAYER_SCORE_FREEKICK:
        return "markets-player-score-freekick";
      case MarketTypes.PLAYER_SCORE_HEADER:
        return "markets-player-score-header";
      case MarketTypes.BOTH_PLAYERS_SCORE:
        return "markets-both-players-score";
      case MarketTypes.PLAYER_SHOWN_CARD:
        return "markets-player-shown-card";
      case MarketTypes.PLAYER_SHOWN_RED_CARD:
        return "markets-player-shown-red-card";

      default:
        return marketType;
    }
  }

  static getTranslationIdForEvent(eventType: string): string {
    switch (eventType) {
      case RunnerTypes.HOME:
        return "events-home";

      case RunnerTypes.AWAY:
        return "events-away";

      case RunnerTypes.DRAW:
        return "events-draw";

      case RunnerTypes.UNDER:
        return "events-under";

      case RunnerTypes.OVER:
        return "events-over";

      case RunnerTypes.TEAM1:
        return "events-team1";

      case RunnerTypes.TEAM2:
        return "events-team2";

      default:
        return eventType;
    }
  }

  // Return a suffix to be added to certain markets under certain conditions, e.g. (Inc. OT) for full time ice hockey
  static getMarketNameSuffix: (
    marketType: string,
    marketPeriod: string,
    sport: string
  ) => string = (marketType: string, marketPeriod: string, sport: string) => {
    if (
      marketPeriod === MarketPeriods.FULL_EVENT &&
      sport === SportsNameType.ICE_HOCKEY &&
      (marketType === MarketTypes.TOTAL_GOALS_AWAY ||
        marketType === MarketTypes.TOTAL_GOALS_HOME)
    ) {
      return "markets-suffix-incot";
    } else if (
      (marketPeriod === MarketPeriods.FULL_EVENT &&
        sport === SportsNameType.BASKETBALL &&
        marketType === MarketTypes.WINNING_MARGIN) ||
      (marketPeriod === MarketPeriods.REGULATION_TIME &&
        sport === SportsNameType.ICE_HOCKEY)
    ) {
      return "markets-suffix-noot";
    } else {
      return "markets-suffix-blank";
    }
  };

  static getTranslationIdForDangerZone(dangerZoneState: string): string {
    switch (dangerZoneState) {
      case DangerZoneStates.HOME_GOAL:
      case DangerZoneStates.AWAY_GOAL:
        return "drawerincidents goal";

      case DangerZoneStates.HOME_PENALTY:
      case DangerZoneStates.AWAY_PENALTY:
        return "drawerincidents penalty";

      case DangerZoneStates.HOME_ATTACKING_FREEKICK:
      case DangerZoneStates.AWAY_ATTACKING_FREEKICK:
      case DangerZoneStates.HOME_DANGEROUS_FREEKICK:
      case DangerZoneStates.AWAY_DANGEROUS_FREEKICK:
        return "drawerincidents freekick";

      case DangerZoneStates.HOME_CORNER:
      case DangerZoneStates.AWAY_CORNER:
      case DangerZoneStates.HOME_CORNER_DANGER:
      case DangerZoneStates.AWAY_CORNER_DANGER:
        return "drawerincidents corner kick";

      // BET-5712
      case DangerZoneStates.AWAY_VAR:
      case DangerZoneStates.HOME_VAR:
        return "var";

      // BET-5712
      case DangerZoneStates.HOME_END_VAR:
      case DangerZoneStates.AWAY_END_VAR:
        return "var ended";

      // BET-5712 possible var event incident has no particapant id so no side is returned from API
      case DangerZoneStates.POSSIBLE_VAR:
        return "possible var";

      // BET-5712 possible var event incident has no particapant id so no side is returned from API
      case DangerZoneStates.POSSIBLE_VAR_CANCELLED:
        return "var cancelled";

      case DangerZoneStates.HOME_DANGEROUS_ATTACK:
      case DangerZoneStates.AWAY_DANGEROUS_ATTACK:
        return "drawerincidents attack";

      default:
        return dangerZoneState;
    }
  }

  static getTranslationIdForIncidentType(incidentTypeState: string): string {
    switch (incidentTypeState) {
      case IncidentTypeStates.HOME_GOAL:
      case IncidentTypeStates.AWAY_GOAL:
        return "drawerincidents goal";

      case IncidentTypeStates.HOME_CORNER:
      case IncidentTypeStates.AWAY_CORNER:
        return "drawerincidents corner kick";

      case IncidentTypeStates.HOME_YELLOW_CARD:
      case IncidentTypeStates.AWAY_YELLOW_CARD:
        return "drawerincidents yellow card";

      case IncidentTypeStates.HOME_RED_CARD:
      case IncidentTypeStates.AWAY_RED_CARD:
        return "drawerincidents red card";

      default:
        return incidentTypeState;
    }
  }

  static getTranslationIdForCryptoCurrencyType(cryptoCurrency: string): string {
    switch (cryptoCurrency) {
      case CryptoCurrencyTypes.BTC:
        return "cashier-bitcoin";

      case CryptoCurrencyTypes.BCH:
        return "cashier-bitcoin-cash";

      case CryptoCurrencyTypes.ETH:
        return "cashier-ethereum";

      case CryptoCurrencyTypes.USDT_ERC20:
        return "cashier-tether";

      case CryptoCurrencyTypes.USDT_TRC20:
        return "cashier-tether";

      default:
        return cryptoCurrency;
    }
  }
}
